<template>
    <el-dialog :close-on-click-modal="false" title="出库登记" :visible="digVisible" width="746px" @close="closeDig"
        destroy-on-close>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
            <!-- <el-form-item label="编号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入编号" style="width:206px;"></el-input>
        </el-form-item> -->
            <el-form-item :label="`场所`">
                <el-select v-model="training_room" style="width:206px;" filterable :placeholder="`请选择场所`"
                    @change="handleChangeRoom">
                    <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
                        :value="item.training_name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="`${$store.state.themeTitle}耗材名称`" prop="consumed_product_id">
                <el-select v-model="ruleForm.consumed_product_id" style="width:266px;" filterable clearable
                    :placeholder="`请先选择场所，再选择${$store.state.themeTitle}耗材`" @change="handleComsumeChange">
                    <el-option v-for="item in $store.state.consumeIntos" :key="item.id" :label="item.name"
                        :value="item.id" :disabled="item.remainder_quantity * 1 == 0">
                        <p>{{ item.name }}</p>
                        <p v-if="item.number" class="el-option-tips">编号：{{ item.number }}</p>
                        <p v-if="item.remainder_quantity" class="el-option-tips">当前库存：{{ item.remainder_quantity }}</p>
                        <p v-if="item.price" class="el-option-tips">价格：{{ item.price }}</p>
                        <p v-if="item.unit" class="el-option-tips">单位：{{ item.unit }}</p>
                        <p v-if="item.size" class="el-option-tips">规格：{{ item.size }}</p>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop="consume" label-width="20px">
                （库存数量：{{ consumNumber }} / 价格：{{ ruleForm.price }}元）
            </el-form-item>
            <el-form-item label="使用用途" prop="usage">
                <el-select v-model="ruleForm.usage" style="width:206px;" filterable clearable placeholder="请先选择使用用途"
                    @change="handleUseChange">
                    <el-option value="教学" label="教学"></el-option>
                    <el-option value="竞赛" label="竞赛"></el-option>
                    <el-option value="其他" label="其他"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="使用周数" prop="used_week">
                <el-input-number v-model="ruleForm.used_week" :min="0" placeholder="请输入"
                    style="width:206px;"></el-input-number>
            </el-form-item>
            <el-form-item label="班  级" prop="class_name">
                <!-- <el-input v-model="ruleForm.class_name" placeholder="请输入班级" style="width:206px;"></el-input> -->

                <OrganDialog ref="organDia" :multiple="true" :checkStrictly="true" :checkLevel="3"  @getSelect="getSelect" :level="[1, 2, 3]"
                    @handleOrganQuery="handleOrganMultipleQueryNeed({key:'class_name',needKey:'name'})">
                </OrganDialog>
                <el-input v-model="ruleForm.class_name" placeholder="请选择班级" style="width:206px;" @focus="dialogOpen"
                    @clear="handeleClear" clearable></el-input>

            </el-form-item>
            <el-form-item label="使用数量" prop="consume_quantity">
                <el-input-number v-model="ruleForm.consume_quantity" :min="0" :max="consumNumber*1" placeholder="请输入使用数量"
                    style="width:206px;"></el-input-number>
            </el-form-item>
            <el-form-item label="出库时间" prop="date">
                <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间"
                    v-model="ruleForm.date" style="width:206px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="领用人" prop="lyr">
                <el-input v-model="ruleForm.lyr" placeholder="请输入" style="width:206px;"></el-input>
            </el-form-item>
            <el-form-item :label="`所属课程`" prop="course_name" v-if="ruleForm.usage == '教学'">
                <el-select v-model="ruleForm.course_name" clearable filterable remote :remote-method="getCourseList"
                    :loading="loading1" :placeholder="`请输入搜索`" style="width: 206px;">
                    <el-option v-for="item in courseList" :key="item.id" :label="item.course_name"
                        :value="item.course_name">
                        <p>{{ item.course_name }}（{{ item.course_no }}）</p>
                        <p v-if="item.training_name" class="el-option-tips">所属实训室：{{ item.training_name }}</p>
                        <p v-if="item.class_teacher" class="el-option-tips">任课老师：{{ item.class_teacher }}</p>
                        <p v-if="item.term" class="el-option-tips">学年学期：{{ item.xn }} {{ item.term }}</p>
                        <p v-if="item.structure_1" class="el-option-tips">组织结构：{{ item.structure_1 }}-{{
                            item.structure_2
                        }}-{{
                                item.class_name }}</p>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="人 数" prop="student_num" v-if="ruleForm.usage == '教学'">
                <el-input-number v-model="ruleForm.student_num" placeholder="请输入人数"
                    style="width:206px;"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="价  格" prop="price">
          <el-input v-model.number="ruleForm.price" placeholder="请输入价格" style="width:198px;"></el-input> 元
        </el-form-item> -->
            <el-form-item style="margin-top:8px;width:100%;text-align:right;">
                <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
                <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinValidate } from '@/assets/js/mixin/validate';
export default {
    props: ['digVisible'],
    mixins: [mixinOrgan, mixinValidate],
    data() {
        return {
            training_room: '',
            ruleForm: {
                number: '',
                name: '',
                consumed_product_id: '',
                consume_quantity: '',
                // consume_at:'',
                price: 0,
                usage: '',
                class_name: '',
                course_name: '',
                student_num: '',
                used_week: '',
                lyr: '',
                record_number: '',
                apply_id: '',
                date: ''
            },
            ruleFormTep: {},
            consumNumber: 0,
            rules: {
                consume_quantity: [
                    { required: true, message: '使用数量不能为空' },
                    { validator: this.checkfloat, trigger: 'blur' },
                ],
                used_week: [
                    { required: true, message: '使用周数不能为空' },
                    { type: 'number', message: '使用周数必须为数字值' },
                ],
                usage: [{ required: true, message: '请选择', trigger: 'change' }],
                class_name: [{ required: true, message: '请选择' }],
                consumed_product_id: [{ required: true, message: '请选择', trigger: 'change' }],
                lyr: [{ required: true, message: '请输入', trigger: 'blur' }],
            },
            loading1: false,
            courseList: [],
        };
    },
    mounted() {
        this.$store.dispatch('getTarinMent');
        this.ruleFormTep = this.$until.easyDeepCopy(this.ruleForm)
    },
    methods: {
        async createMethod() {
            this.ruleForm.record_number = new Date().getTime() + ''
            let params = this.$until.deleteNullPrototype(this.ruleForm);
            // console.log(params);
            // return
            let res = await this.$api.instance.interfaceServer('api/consume/record/createUpdate', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '提交成功！',
                });
                this.closeDig(true);
            }
        },
        clearForm() {
            this.courseList = []
            this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
            this.training_room = ''
            this.$nextTick(() => {
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.clearValidate()
                }
            });
        },
        async handleEditInit(row) {
            if (row.kc_id && JSON.stringify(this.courseList).indexOf(row.kc_id) == -1) {
                this.courseList.push({ id: row.kc_id, course_name: row.kcmc })
            }
            this.ruleForm.apply_id = row.id
            this.training_room = row.training_room
            if (row.training_room) {
                await this.handleChangeRoom(row.training_room)
                this.$nextTick(() => {
                    this.ruleForm.consumed_product_id = row.consumed_product_id
                    this.handleComsumeChange(row.consumed_product_id)
                })
            }
            this.ruleForm.lyr = row.lyr
            this.ruleForm.usage = row.syyt
            this.ruleForm.consume_quantity = row.apply_quantity
            this.handleUseChange(row.syyt)
            this.ruleForm.used_week = row.syzs
            this.ruleForm.class_name = row.bj
            this.ruleForm.date = row.apply_date
            this.ruleForm.student_num = row.rs
            this.ruleForm.course_name = row.kcmc ? row.kcmc : ''

        },
        closeDig(flag) {
            this.$emit('closeDig', flag);
        },
        async handleChangeRoom(val) {
            await this.$store.dispatch('getConsum', { training_room: val });
        },
        handleUseChange(val) {
            if (val != '教学') {
                this.ruleForm.course_name = ''
                this.ruleForm.student_num = ''
            }
        },
        handleComsumeChange(val) {
            console.log(val, this.$store.state.consumeIntos);
            this.ruleForm.name = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'name', val);
            this.ruleForm.number = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'number', val);
            this.ruleForm.price = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'price', val);
            const consumNumber = this.$until.getLabelName(this.$store.state.consumeIntos, 'id', 'remainder_quantity', val);
            this.consumNumber = consumNumber ? consumNumber : 0;
        },
        async getCourseList(query) {
            // if (this.courseList && this.courseList.length) {
            //   return
            // }
            this.loading1 = true
            let res = await this.$api.query.getClassPlanList({ page: 1, size: 9999, apply_status: 'pass', course_name: query });
            this.loading1 = false
            if (res.code == 0 && res.data) {
                this.courseList = res.data.data;
            }
        },
        resetForm(formName) {
            this.ruleForm.name = '';
            this.ruleForm.number = '';
            this.ruleForm.price = 0;
            this.consumNumber = 0;
            this.$refs[formName].resetFields();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.createMethod();
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped></style>
